package team.platforma.multiplatform_material_extension.util

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

class DeferredJob(private val coroutineScope: CoroutineScope) {
    private var job: Job? = null
    private var lastConstraint: CharSequence? = null
    fun result(
        delay: Long,
        input: CharSequence?,
        result: (output: CharSequence) -> Unit
    ) {
        if (!input.isNullOrEmpty()) {
            lastConstraint = input
            job?.cancel()

            job = coroutineScope.launch {
                delay(delay)
                if (input == lastConstraint) {
                    result(input)
                }
            }
        } else {
            job?.cancel()
            result(input ?: "")
        }
    }
}
